import 'css-chunksrc/client/scenes/eventPopup/styles.scss';export default {
  "eventPopup": "_eventPopup_15dwr_1",
  "header": "_header_15dwr_13",
  "dateTimeInfo": "_dateTimeInfo_15dwr_20",
  "timeRange": "_timeRange_15dwr_27",
  "date": "_date_15dwr_20",
  "actions": "_actions_15dwr_38",
  "actionButton": "_actionButton_15dwr_44",
  "title": "_title_15dwr_62",
  "name": "_name_15dwr_71",
  "description": "_description_15dwr_80",
  "projectInfo": "_projectInfo_15dwr_89",
  "label": "_label_15dwr_97",
  "projectBadge": "_projectBadge_15dwr_104",
  "icon": "_icon_15dwr_112",
  "trashIcon": "_trashIcon_15dwr_120",
  "editIcon": "_editIcon_15dwr_126",
  "link": "_link_15dwr_132",
  "projectName": "_projectName_15dwr_140",
  "customFields": "_customFields_15dwr_153"
};